// extracted by mini-css-extract-plugin
export default {"title":"PrimaryBusinessAddress_title__9kMmG","description":"PrimaryBusinessAddress_description__C22kV"};